import { langMap } from '@/config/language'
export default function ({ store, i18n }) {
  const lang = langMap[i18n.loadedLanguages[0]] || 'en-US'
  // 相当于路由守卫
  if (store.state.lang.lang === lang) return
  store.commit('lang/getCurLang', lang)
}
